import { useQuery } from '@tanstack/react-query';
import { useMyWallet } from 'hooks/queries/marketplace/wallet';
import useApi from 'hooks/useApi';
import useAuth from 'hooks/useAuth';
import useUserApi from 'hooks/UserApi/useUserApi';
import notificationsFactory from 'utils/factories/notifications';
import getULID from 'utils/getULID';
import {
  getHeaderAccountClassicItems,
  headerAccountFooterImage,
  headerScanItem,
  walletItem,
} from '../data/userHeaderAccount';
import { useMemo } from 'react';
import { getShopHeaderAccountItems } from '../data/ShopHeaderAccount';

const useUserNav = () => {
  const { user, isLoading } = useUserApi();
  const { logout } = useAuth();

  const apiClient = useApi();
  const {
    queryResult: { data: wallet, isLoading: isWalletLoading },
    isWalletActivated,
  } = useMyWallet();

  const { data: unread } = useQuery({
    queryKey: notificationsFactory.unread(),
    queryFn: async () => {
      const apiData = await apiClient.notifications.apiNotificationsunreadGet();

      return apiData.data.unread;
    },
    enabled: !!user && !isLoading,
  });

  const shopId = getULID(user?.shop);

  const handleLogout = async () => {
    await logout();
  };
  const menuItems = useMemo(
    () =>
      shopId
        ? getShopHeaderAccountItems({ logout: handleLogout, notificationCount: unread })
        : getHeaderAccountClassicItems({ logout: handleLogout, notificationCount: unread }),
    [unread],
  );

  return {
    menuItems,
    walletItem: shopId ? undefined : walletItem,
    scanItem: headerScanItem,
    isWalletLoading,
    user,
    isLoading,
    wallet,
    headerAccountFooterImage,
    isWalletActivated,
  };
};

export default useUserNav;
